import { Icon, IconName } from './Icon';

export function EmptyState({
  icon = 'sparkles',
  title,
  body,
  cta,
}: {
  icon?: IconName;
  title: string;
  body?: string;
  cta?: JSX.Element;
}): JSX.Element {
  return (
    <div className="flex flex-col items-center gap-3 rounded-[1.75rem] border border-dashed border-ink-700/70 bg-ink-900/40 px-6 py-10 text-center">
      <div className="flex h-14 w-14 items-center justify-center rounded-2xl bg-grad-primary text-white shadow-soft">
        <Icon name={icon} size={26} />
      </div>
      <div className="text-base font-semibold text-ink-50">{title}</div>
      {body && <div className="max-w-[280px] text-sm text-ink-300">{body}</div>}
      {cta && <div className="mt-2">{cta}</div>}
    </div>
  );
}
